import { SeoMetaData } from '@cms-max/cms-browser-api-client'
import { Component } from '@cms-max/medicare-api-sdk'

const createMcfBlastAnalytics = (pageName: string) => ({
  page_type: 'application',
  site_section: 'medicare complaint form',
  page_name: `medicare complaint form: ${pageName}`
} as const)

export const mcfSeoMetaData: SeoMetaData[] = [
  {
    path: '/medicare-complaint',
    isQmMaskingEnabled: true,
    blastAnalytics: createMcfBlastAnalytics('landing page'),
    seo: {
      en: {
        title: 'Medicare Complaint Form - Start',
        description: 'You are now able to submit feedback about your Medicare health plan or prescription drug plan directly to Medicare using the form below. The Centers for Medicare & Medicaid Services values your feedback and will use it to continue to improve the quality of the Medicare program. If you have any other feedback or concerns, or if this is an urgent matter, please call 1-800-MEDICARE (1-800-633-4227). TTY/TTD users can call 1-877-486-2048.'
      },
      es: {
        title: 'Formulario de quejas de Medicare',
        description: 'Ahora usted puede presentar sus comentarios o quejas acerca de su plan de salud de Medicare o su plan de recetas médicas directamente a Medicare, utilizando el formulario que encontrará más abajo. Los Centros de Servicios de Medicare y Medicaid aprecian sus comentarios y los utilizarán para seguir mejorando la calidad del programa Medicare. Si usted tiene otros comentarios o quejas, o si su asunto es urgente, por favor lllame al 1-800-MEDICARE (1-800-633-4227). Los usuarios de TTY deben llamar al 1-877-486-2048.'
      }
    }
  },
  {
    path: '/medicare-complaint/step1',
    isQmMaskingEnabled: true,
    blastAnalytics: createMcfBlastAnalytics('verification page'),
    seo: {
      en: {
        title: 'Medicare Complaint Form - Verification',
        description: 'You are now able to submit feedback about your Medicare health plan or prescription drug plan directly to Medicare using the form below. The Centers for Medicare & Medicaid Services values your feedback and will use it to continue to improve the quality of the Medicare program. If you have any other feedback or concerns, or if this is an urgent matter, please call 1-800-MEDICARE (1-800-633-4227). TTY/TTD users can call 1-877-486-2048.'
      },
      es: {
        title: 'Formulario de quejas de Medicare', // TODO: spanish content
        description: 'Ahora usted puede presentar sus comentarios o quejas acerca de su plan de salud de Medicare o su plan de recetas médicas directamente a Medicare, utilizando el formulario que encontrará más abajo. Los Centros de Servicios de Medicare y Medicaid aprecian sus comentarios y los utilizarán para seguir mejorando la calidad del programa Medicare. Si usted tiene otros comentarios o quejas, o si su asunto es urgente, por favor lllame al 1-800-MEDICARE (1-800-633-4227). Los usuarios de TTY deben llamar al 1-877-486-2048.'
      }
    }
  },
  {
    path: '/medicare-complaint/step2',
    isQmMaskingEnabled: true,
    blastAnalytics: createMcfBlastAnalytics('complaint page'),
    seo: {
      en: {
        title: 'Medicare Complaint Form - Complaint',
        description: 'You are now able to submit feedback about your Medicare health plan or prescription drug plan directly to Medicare using the form below. The Centers for Medicare & Medicaid Services values your feedback and will use it to continue to improve the quality of the Medicare program. If you have any other feedback or concerns, or if this is an urgent matter, please call 1-800-MEDICARE (1-800-633-4227). TTY/TTD users can call 1-877-486-2048.'
      },
      es: {
        title: 'Formulario de quejas de Medicare', // TODO: spanish content
        description: 'Ahora usted puede presentar sus comentarios o quejas acerca de su plan de salud de Medicare o su plan de recetas médicas directamente a Medicare, utilizando el formulario que encontrará más abajo. Los Centros de Servicios de Medicare y Medicaid aprecian sus comentarios y los utilizarán para seguir mejorando la calidad del programa Medicare. Si usted tiene otros comentarios o quejas, o si su asunto es urgente, por favor lllame al 1-800-MEDICARE (1-800-633-4227). Los usuarios de TTY deben llamar al 1-877-486-2048.'
      }
    }
  },
  {
    path: '/medicare-complaint/step2b',
    isQmMaskingEnabled: true,
    blastAnalytics: createMcfBlastAnalytics('complaint page'),
    seo: {
      en: {
        title: 'Medicare Complaint Form - Complaint',
        description: 'You are now able to submit feedback about your Medicare health plan or prescription drug plan directly to Medicare using the form below. The Centers for Medicare & Medicaid Services values your feedback and will use it to continue to improve the quality of the Medicare program. If you have any other feedback or concerns, or if this is an urgent matter, please call 1-800-MEDICARE (1-800-633-4227). TTY/TTD users can call 1-877-486-2048.'
      },
      es: {
        title: 'Formulario de quejas de Medicare', // TODO: spanish content
        description: 'Ahora usted puede presentar sus comentarios o quejas acerca de su plan de salud de Medicare o su plan de recetas médicas directamente a Medicare, utilizando el formulario que encontrará más abajo. Los Centros de Servicios de Medicare y Medicaid aprecian sus comentarios y los utilizarán para seguir mejorando la calidad del programa Medicare. Si usted tiene otros comentarios o quejas, o si su asunto es urgente, por favor lllame al 1-800-MEDICARE (1-800-633-4227). Los usuarios de TTY deben llamar al 1-877-486-2048.'
      }
    }
  },
  {
    path: '/medicare-complaint/success',
    isQmMaskingEnabled: true,
    blastAnalytics: createMcfBlastAnalytics('confirmation page'),
    seo: {
      en: {
        title: 'Medicare Complaint Form - Complaint Submitted',
        description: 'You are now able to submit feedback about your Medicare health plan or prescription drug plan directly to Medicare using the form below. The Centers for Medicare & Medicaid Services values your feedback and will use it to continue to improve the quality of the Medicare program. If you have any other feedback or concerns, or if this is an urgent matter, please call 1-800-MEDICARE (1-800-633-4227). TTY/TTD users can call 1-877-486-2048.'
      },
      es: {
        title: 'Formulario de quejas de Medicare', // TODO: spanish content
        description: 'Ahora usted puede presentar sus comentarios o quejas acerca de su plan de salud de Medicare o su plan de recetas médicas directamente a Medicare, utilizando el formulario que encontrará más abajo. Los Centros de Servicios de Medicare y Medicaid aprecian sus comentarios y los utilizarán para seguir mejorando la calidad del programa Medicare. Si usted tiene otros comentarios o quejas, o si su asunto es urgente, por favor lllame al 1-800-MEDICARE (1-800-633-4227). Los usuarios de TTY deben llamar al 1-877-486-2048.'
      }
    }
  }
].map(seoMetaData => ({
  ...seoMetaData,
  component: Component.Mcf
}))
